import { array } from 'io-ts/lib/Decoder';

import { Id as TransactionId } from '../../../../../transaction/Id';

export const Request = array(TransactionId);
